import { defineNuxtPlugin, type NuxtApp } from 'nuxt/app'
import { Native } from '~/plugins/platform/native'
import { Connection } from '~/plugins/platform/Connection'
import type { Plugin } from '~/plugins/plugins'

export class Platform {
  // TODO: Add implementation, network state is currently not used
  private networkState = 'Unknown connection'
  public readonly native: Native

  constructor(private readonly app: NuxtApp) {
    this.native = new Native(this.app)
  }

  public get isNative(): boolean {
    return this.native.isNative
  }

  public get isOffline() {
    return this.networkState === Connection.Offline
  }
}

export class PlatformPlugin {
  private static readonly NUXT_PLUGIN_KEY = 'platform'

  static install: Plugin = (nuxtApp) => {
    nuxtApp.provide(
      PlatformPlugin.NUXT_PLUGIN_KEY,
      PlatformPlugin.setup(nuxtApp)
    )
  }

  private static setup(nuxtApp: any) {
    return new Platform(nuxtApp)
  }
}

export default defineNuxtPlugin(PlatformPlugin.install)
